import {
  ClosePopup,
} from 'quasar';

export default {
  ClosePopup,
};
